import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import { i18nReady } from './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { cargarSentry } from './utils/sentry';
import { trasPrimerPintado } from './utils/trasPrimerPintado';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

if (process.env.REACT_APP_SENTRY_DSN) trasPrimerPintado(cargarSentry);

const root = ReactDOM.createRoot(document.getElementById('root'));

function pintarApp() {
  root.render(
    <React.StrictMode>
      {/* Última red: cubre incluso un fallo del propio App antes de montar sus
          providers. Sin ella, ese caso es pantalla en blanco sin reporte a Sentry. */}
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>
  );
}

// El render espera a que el idioma esté listo, para que quien eligió inglés no
// vea primero un destello de español.
//
// Para casi todo el mundo esto NO retrasa nada: sin preferencia guardada el
// idioma es español, que viaja dentro del bundle, así que `i18nReady` ya viene
// resuelta y el render ocurre en el mismo microtask. Solo espera quien eligió
// inglés en este aparato, y con techo de 2,5 s.
//
// El `.catch` es cinturón y tirantes: `i18nReady` está escrita para no
// rechazarse nunca, pero si alguna vez lo hiciera, este `.then` no correría y
// la consecuencia no sería "en el idioma equivocado", sería PANTALLA EN BLANCO.
// Un fallo del idioma jamás puede costar la app entera.
i18nReady.then(pintarApp).catch(pintarApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// PWA: registra el service worker (solo en producción; en dev no hace nada → sin refresh loops en localhost).
// Precachea el shell de la app para que cargue offline. Auto-actualiza al desplegar (ver serviceWorkerRegistration).
serviceWorkerRegistration.register();
reportWebVitals();
